var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFooterNaverCafe = function SvgIcFooterNaverCafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#767884",
    d: "M12 10c0 2.83-1.294 5.124-5.124 5.124S1.752 12.83 1.752 10l.002-4.376h10.248zM9.287 3.167A3.77 3.77 0 0 0 10.392.5h-2.62A3.77 3.77 0 0 0 4 4.272h2.62c1 0 1.96-.398 2.667-1.105"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#767884",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.316,
    d: "M11.888 7.294a2.213 2.213 0 0 1 0 4.427L10.5 11.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIcFooterNaverCafe;